import { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  IconButton,
  Grid,
  Hidden,
  LinearProgress,
  Tooltip,
  Button,
  Stack,
} from '@mui/material';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import { useHistory } from 'react-router';
import { Formik } from 'formik';
import { MFSubmitButton, MFTextField } from '../../lib/formik';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import { DatePicker } from '../../lib/formik/DatePicker';
import { useDispatch } from 'react-redux';
import { SubHeading } from '../investors/components';
import { addPlan, fundAccess, getPlanDetail, updatePlan } from '../../redux-store/actions/funds';
import {
  accessType,
  addHurdleRate,
  addPlanType,
  ClassPlanProps,
} from '../../redux-store/types/funds';
import MFSelectField from '../../lib/formik/SelectField';
import { Location } from 'history';
import { getFundManagersList, getTrustessList } from '../../redux-store/actions/userManagement';
import { DistributorListType, FundManager, Trustee } from '../../redux-store/types/api-types';
import { addPlanValidation } from '../../utils/schema';
import { MultipleSelect } from '../../lib/formik/MultipleSelectField';
import { getDistributorsListForFilters } from '../../redux-store/actions';
import MFCheckbox from '../../lib/formik/Checkbox';
import {
  allowOnlyNumbers,
  checkIfApplicable,
  currencyConversion,
  isAccreditedInvestorApplicable,
} from '../../utils/utilityFunctions';
import {
  EXCLUDE_CLAUSE_MASTER,
  excludeClauseSubLabel,
  yesNoMaster,
  CurrencyMaster,
  defaultCurrency,
} from '../../utils/constant';
import { DataTable } from '../DataTable';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { ConfirmationDialog } from '../commonComponents';
import AddIcon from '@mui/icons-material/Add';
import UseRadioGroup from '../../lib/formik/Radio';

type updatedAddHurdleRate = addHurdleRate & {
  sno: number;
};

const newHurdleRate: updatedAddHurdleRate = {
  id: null,
  planId: '',
  hurdleRate: '',
  performanceFee: 0,
  isActive: true,
  sno: 0,
};

type updatedAddPlanType = {
  hurdlerates: updatedAddHurdleRate[];
  isApplicableForDistributor: boolean;
} & addPlanType;

const initialValues: updatedAddPlanType = {
  // id: '',
  schemeId: 0,
  planCode: '',
  planDescription: '',
  schemeNature: '',
  registrationNumber: '',
  schemeCategory: '',
  country: '',
  currency: defaultCurrency,
  transactionCurrency: defaultCurrency,
  schemeStartDate: `${new Date()}`,
  lockInPeriod: '',
  lockInExtension: '',
  faceValue: 0,
  fundAddress1: '',
  fundManagerId: null,
  trusteeId: null,
  fundAddress2: '',
  fundAddress3: '',
  inActive: true,
  isActive: true,
  custodian: '',
  setupFee: 0,
  minCommitmentAmount: null,
  maxCommitmentAmount: 0,
  minContributionPercentage: 0,
  managementFee: 0,
  operatingExpenses: null,
  placementCost: null,
  performanceFee: 0,
  hurdleRate: 0,
  tcLink: '',
  hurdlerates: [newHurdleRate],
  excludeClause: '',
  exitCharge: '',
  exitChargeApplicable: '',
  distributorIds: null,
  isApplicableForDirect: false,
  isApplicableForDistributor: false,
  distMangementFee: '',
  distPerformanceFee: '',
  managementFeeCheck: false,
  managementFeeAfterCommitment: 0,
  accreditedInvestorApplicable: '',
  accreditedMinCommitmentAmount: null,
};

export default function AddPlan({
  location,
}: {
  location: Location<{ fundId: string; PlanId: string; checkExcludeClause: string }>;
}): JSX.Element {
  const history = useHistory();
  const dispatch = useDispatch();
  const [fundManager, setFundManager] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [planInitial, setPlanInitial] = useState(initialValues);
  const [access, setAccess] = useState(false);
  const { fundId, PlanId, checkExcludeClause } = location.state || {};
  const [trustee, setTrustee] = useState<any[]>([]);
  const [hurdleRateToDelete, setHurdleRateToDelete] = useState<{
    index: number;
  } | null>(null);
  const columns: any = [
    {
      header: 'Hurdle Rate(PA) / Hurdle Rate of Return',
      label: 'hurdleRate',
      renderEditDeleteCell: (row: updatedAddHurdleRate): JSX.Element => {
        return (
          <>
            <Stack
              sx={{
                flexDirection: 'row',
                alignItems: 'center',
                display: 'inline-flex',
                width: 350,
                maxWidth: '100%',
                py: 1,
                '& .MuiFormControl-root': { width: '100%', m: 0 },
              }}>
              <MFTextField
                name={`hurdlerates.${row.sno}.hurdleRate`}
                // label="Hurdle Rate"
                placeholder="Enter hurdle rate"
              />
            </Stack>
          </>
        );
      },
    },
    {
      header: 'Performance Fees(PA)/ Additional return',
      label: 'performanceFee',
      renderEditDeleteCell: (row: updatedAddHurdleRate): JSX.Element => {
        return (
          <Stack
            sx={{
              flexDirection: 'row',
              alignItems: 'center',
              display: 'inline-flex',
              width: 350,
              maxWidth: '100%',
              py: 1,
              '& .MuiFormControl-root': { width: '100%', m: 0 },
            }}>
            <MFTextField
              name={`hurdlerates.${row.sno}.performanceFee`}
              // label="Performance Fee"
              placeholder="Enter Performance Fee"
              type="number"
              onKeyDown={(e) => {
                allowOnlyNumbers(e);
              }}
              trimOnBlur={false}
            />
          </Stack>
        );
      },
    },
  ];
  const AccessViewOrEditCell = [
    {
      header: '',
      renderCell: (row: updatedAddHurdleRate): JSX.Element => {
        return (
          <>
            <Stack
              sx={{
                flexDirection: 'row',
                alignItems: 'center',
                display: 'inline-flex',
                maxWidth: '100%',
                py: 1.5,
                '& .MuiFormControl-root': { width: '100%', m: 0 },
              }}>
              <Tooltip title="Delete">
                <IconButton
                  sx={{
                    ':hover': {
                      bgcolor: '#F4FCFC',
                    },
                  }}
                  onClick={() => setHurdleRateToDelete({ index: row.sno })}>
                  <DeleteOutlineIcon color="error" fontSize="small" />
                </IconButton>
              </Tooltip>
            </Stack>
          </>
        );
      },
    },
  ];
  const [distributorList, setDistributorList] = useState<DistributorListType[]>([]);

  useEffect(() => {
    let isComponentAlive = true;
    (async function () {
      try {
        setLoading(true);
        const trusteeList = (await dispatch(getTrustessList())) as unknown as Trustee[];
        const fundManagerList = (await dispatch(getFundManagersList())) as unknown as FundManager[];
        const { fundSetupAccess } = (await dispatch(fundAccess())) as unknown as accessType;
        const distributorLists = (await dispatch(
          getDistributorsListForFilters()
        )) as unknown as DistributorListType[];
        setAccess(fundSetupAccess);
        setFundManager(fundManagerList);
        setTrustee(trusteeList);
        setDistributorList(distributorLists);
        if (PlanId) {
          const GetFundDetail = (await dispatch(
            getPlanDetail(PlanId)
          )) as unknown as ClassPlanProps;
          const {
            planCode,
            schemeId,
            planDescription,
            schemeNature,
            registrationNumber,
            schemeCategory,
            country,
            currency,
            schemeStartDate,
            lockInPeriod,
            lockInExtension,
            inActive,
            faceValue,
            fundAddress1,
            fundAddress2,
            fundAddress3,
            isActive,
            custodian,
            setupFee,
            minCommitmentAmount,
            maxCommitmentAmount,
            minContributionPercentage,
            managementFee,
            operatingExpenses,
            placementCost,
            performanceFee,
            hurdleRate,
            fundManagerId,
            trusteeId,
            tcLink,
            hurdlerates = [],
            excludeClause,
            exitCharge,
            exitChargeApplicable,
            distributorDetails,
            isApplicableForDirect,
            distMangementFee,
            distPerformanceFee,
            managementFeeAfterCommitment,
            managementFeeCheck,
            transactionCurrency,
            accreditedInvestorApplicable = '',
            accreditedMinCommitmentAmount,
          } = GetFundDetail || {};

          setPlanInitial({
            ...planInitial,
            planCode,
            schemeId,
            planDescription,
            schemeNature,
            registrationNumber,
            schemeCategory,
            country,
            currency,
            schemeStartDate,
            lockInPeriod,
            lockInExtension,
            inActive,
            faceValue,
            fundAddress1,
            fundAddress2,
            fundAddress3,
            isActive,
            custodian,
            setupFee,
            minCommitmentAmount,
            maxCommitmentAmount,
            minContributionPercentage,
            managementFee,
            operatingExpenses,
            placementCost,
            performanceFee,
            hurdleRate,
            fundManagerId,
            trusteeId,
            tcLink,
            hurdlerates: hurdlerates.length
              ? hurdlerates.map((obj, index) => {
                  return { ...obj, sno: index };
                })
              : [{ ...newHurdleRate, planId: GetFundDetail.id }],
            excludeClause,
            exitCharge,
            exitChargeApplicable,
            distributorIds: distributorDetails.distributorIds || null,
            isApplicableForDirect: isApplicableForDirect || false,
            isApplicableForDistributor: distributorDetails.distributorIds.length > 0 ? true : false,
            distMangementFee,
            distPerformanceFee,
            managementFeeAfterCommitment,
            managementFeeCheck,
            transactionCurrency,
            accreditedInvestorApplicable,
            accreditedMinCommitmentAmount,
          });
        }
        if (!isComponentAlive) return;
        setLoading(false);
      } catch (e) {
        console.error((e as Error).message);
      } finally {
        if (isComponentAlive) {
          setLoading(false);
        }
      }
    })();
    return () => {
      isComponentAlive = false;
    };
  }, []);

  const onSubmit = async (values: updatedAddPlanType) => {
    try {
      const {
        planCode,
        schemeId,
        planDescription,
        schemeNature,
        registrationNumber,
        schemeCategory,
        country,
        currency,
        schemeStartDate,
        lockInPeriod,
        lockInExtension,
        inActive,
        faceValue,
        fundAddress1,
        fundAddress2,
        fundAddress3,
        isActive,
        custodian,
        setupFee,
        minCommitmentAmount,
        maxCommitmentAmount,
        minContributionPercentage,
        managementFee,
        operatingExpenses,
        placementCost,
        performanceFee,
        hurdleRate,
        fundManagerId,
        trusteeId,
        tcLink,
        hurdlerates = [],
        excludeClause,
        exitCharge,
        exitChargeApplicable,
        distributorIds,
        isApplicableForDirect,
        distMangementFee,
        distPerformanceFee,
        managementFeeCheck,
        managementFeeAfterCommitment,
        transactionCurrency,
        accreditedInvestorApplicable,
        accreditedMinCommitmentAmount,
      } = values;

      if (!PlanId) {
        await dispatch(
          addPlan({
            schemeId: fundId,
            planCode,
            planDescription,
            schemeNature,
            registrationNumber,
            schemeCategory,
            country,
            currency,
            schemeStartDate,
            lockInPeriod,
            lockInExtension,
            fundManagerId,
            trusteeId,
            inActive,
            faceValue,
            fundAddress1,
            fundAddress2,
            fundAddress3,
            isActive,
            custodian,
            setupFee: setupFee ? setupFee : 0,
            minCommitmentAmount,
            maxCommitmentAmount,
            minContributionPercentage: minContributionPercentage ? minContributionPercentage : 0,
            managementFee: managementFee ? managementFee : 0,
            operatingExpenses:
              operatingExpenses || operatingExpenses === 0 ? operatingExpenses : null,
            placementCost: placementCost || placementCost === 0 ? placementCost : null,
            performanceFee: performanceFee ? performanceFee : 0,
            hurdleRate: hurdleRate ? hurdleRate : 0,
            tcLink,
            hurdlerates: hurdlerates.filter((obj) => obj.isActive || obj.id),
            excludeClause: checkIfApplicable(checkExcludeClause) ? excludeClause : '',
            exitCharge: checkIfApplicable(exitChargeApplicable) ? exitCharge : '',
            exitChargeApplicable,
            distributorIds,
            isApplicableForDirect,
            distMangementFee,
            distPerformanceFee,
            managementFeeCheck,
            managementFeeAfterCommitment: managementFeeCheck ? managementFeeAfterCommitment : null,
            transactionCurrency,
            accreditedInvestorApplicable,
            accreditedMinCommitmentAmount: isAccreditedInvestorApplicable(
              accreditedInvestorApplicable
            )
              ? accreditedMinCommitmentAmount
              : null,
          })
        );
      } else {
        await dispatch(
          updatePlan(Number(PlanId), {
            schemeId,
            planCode,
            planDescription,
            schemeNature,
            registrationNumber,
            schemeCategory,
            country,
            currency,
            schemeStartDate,
            lockInPeriod,
            lockInExtension,
            fundManagerId,
            trusteeId,
            inActive,
            faceValue,
            fundAddress1,
            fundAddress2,
            fundAddress3,
            isActive,
            custodian,
            setupFee: setupFee ? setupFee : 0,
            minCommitmentAmount,
            maxCommitmentAmount,
            minContributionPercentage: minContributionPercentage ? minContributionPercentage : 0,
            managementFee: managementFee ? managementFee : 0,
            operatingExpenses:
              operatingExpenses || operatingExpenses === 0 ? operatingExpenses : null,
            placementCost: placementCost || placementCost === 0 ? placementCost : null,
            hurdleRate: hurdleRate ? hurdleRate : 0,
            performanceFee: performanceFee ? performanceFee : 0,
            tcLink,
            hurdlerates: hurdlerates
              .filter((obj) => obj.isActive || obj.id)
              .map((obj) => {
                return {
                  ...obj,
                  performanceFee:
                    obj.performanceFee || obj.performanceFee === 0 ? obj.performanceFee : null,
                };
              }),
            excludeClause: checkIfApplicable(checkExcludeClause) ? excludeClause : '',
            exitCharge: checkIfApplicable(exitChargeApplicable) ? exitCharge : '',
            exitChargeApplicable,
            distributorIds,
            isApplicableForDirect,
            distMangementFee,
            distPerformanceFee,
            managementFeeCheck,
            managementFeeAfterCommitment: managementFeeCheck ? managementFeeAfterCommitment : null,
            transactionCurrency,
            accreditedInvestorApplicable,
            accreditedMinCommitmentAmount: isAccreditedInvestorApplicable(
              accreditedInvestorApplicable
            )
              ? accreditedMinCommitmentAmount
              : null,
          })
        );
      }
      history.push(PlanId ? 'plan-details' : 'view-plans', {
        fundId: fundId,
        PlanId: PlanId,
        checkExcludeClause: checkExcludeClause,
      });
    } catch (e) {
      console.error((e as Error).message);
    }
  };

  return (
    <>
      <Formik
        initialValues={planInitial}
        onSubmit={onSubmit}
        enableReinitialize={true}
        validationSchema={addPlanValidation(checkExcludeClause, planInitial.managementFeeCheck)}>
        {({ handleSubmit, values, errors, setValues }) => (
          <Box
            sx={{
              bgcolor: 'white',
              boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
              borderRadius: '10px',
              py: { xs: 2, sm: 5 },
              pl: { xs: 0, sm: 5 },
              mt: { xs: 2, sm: 5 },
            }}
            component="form"
            noValidate
            onSubmit={handleSubmit}>
            <Hidden smUp={true}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <IconButton
                  sx={{ height: 'fit-content', p: 0 }}
                  onClick={() =>
                    history.push(PlanId ? 'plan-details' : 'view-plans', {
                      fundId: fundId,
                      // planId: PlanId,
                      PlanId: PlanId,
                      checkExcludeClause: checkExcludeClause,
                    })
                  }>
                  <NavigateBeforeIcon fontSize="medium" sx={{ color: 'common.black' }} />
                </IconButton>
                <Typography
                  sx={{
                    fontSize: 20,
                    fontWeight: 600,
                    color: '#1C2D47',
                  }}>
                  Back
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  my: 2,
                  py: 2,
                  pl: { xs: 3, sm: 0 },
                  color: 'primary.main',
                  bgcolor: 'rgba(238, 244, 251, 0.5)',
                }}>
                <PersonOutlineOutlinedIcon fontSize="large" />
                <Typography
                  sx={{
                    fontSize: 20,
                    fontWeight: 600,
                    pl: 1,
                  }}>
                  Fund Setup
                </Typography>
              </Box>
            </Hidden>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Hidden only="xs">
                <IconButton
                  sx={{ height: 'fit-content', p: 0 }}
                  onClick={() =>
                    history.push(PlanId ? 'plan-details' : 'view-plans', {
                      fundId: fundId,
                      // planId: PlanId,
                      PlanId: PlanId,
                      checkExcludeClause: checkExcludeClause,
                    })
                  }>
                  <NavigateBeforeIcon fontSize="medium" sx={{ color: 'common.black' }} />
                </IconButton>
              </Hidden>
              <Typography
                sx={{
                  fontSize: 20,
                  fontWeight: 600,
                  color: '#1C2D47',
                  pl: { xs: 3, sm: 0 },
                }}>
                {PlanId ? 'Edit Plan' : 'Add Plan'}
              </Typography>
            </Box>

            {loading ? (
              <LinearProgress sx={{ mt: 2 }} />
            ) : (
              <>
                <Grid container rowSpacing={1} columnSpacing={4} px={2}>
                  <SubHeading
                    sx={{
                      color: 'common.blue',
                      letterSpacing: 0.5 + 'px',
                      padding: { xs: '10px 10px', sm: '10px 30px' },
                      ml: { xs: 3.5 },
                    }}>
                    {'Plan Details'}
                  </SubHeading>
                  <Grid item xs={12} sm={6} md={4}>
                    <MFTextField
                      name="planCode"
                      label="Plan Code *"
                      placeholder="Enter Plan Code"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <MFTextField
                      name="planDescription"
                      label="Plan Description *"
                      placeholder="Enter Plan Description"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <MFTextField
                      name="schemeNature"
                      label="Scheme Nature *"
                      placeholder="Enter Scheme Nature"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <MFTextField
                      name="schemeCategory"
                      label="Scheme Category *"
                      placeholder="Enter Scheme Category"
                    />
                  </Grid>
                  {/* <Grid item xs={12} sm={6} md={4}>
                    <MFTextField
                      name="registrationNumber"
                      label="Registration Number *"
                      placeholder="Enter Registration Number"
                    />
                  </Grid> */}
                  <Grid item xs={12} sm={6} md={4}>
                    <MFSelectField
                      name="fundManagerId"
                      label="Investment Manager Name *"
                      items={fundManager.map((item) => ({
                        key: item.name,
                        value: item.id,
                      }))}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <MFSelectField
                      name="trusteeId"
                      label="Trustee Name *"
                      items={trustee.map((item) => ({
                        key: item.name,
                        value: item.id,
                      }))}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <MFTextField name="country" label="Country" placeholder="Enter Country" />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <MFSelectField
                      name="currency"
                      label="Currency"
                      items={Object.keys(CurrencyMaster).map((item) => ({
                        key: CurrencyMaster[item].currency,
                        value: item,
                      }))}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <MFSelectField
                      name="transactionCurrency"
                      label="Transaction Currency"
                      items={Object.keys(CurrencyMaster).map((item) => ({
                        key: CurrencyMaster[item].currency,
                        value: item,
                      }))}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <DatePicker
                      label={'Scheme Start Date'}
                      inputLabelStyles={{
                        transform: 'unset',

                        fontSize: 14,
                        fontWeight: 500,
                        color: 'rgba(0,0,0,0.7)',
                      }}
                      placeholder={'Enter Scheme Start Date'}
                      // maxDate={minDateForContributor()}
                      name={`schemeStartDate`}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <MFTextField
                      name="lockInPeriod"
                      label="Lock In Period(In Year)"
                      placeholder="Enter Lock In Period(In Year)"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <MFTextField
                      name="lockInExtension"
                      label="Lock In Extension(In Year)"
                      disabled={!access}
                      placeholder="Enter Lock In Extension(In Year)"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <MFTextField
                      name="faceValue"
                      label="Face value"
                      placeholder="Enter Face value"
                      type="number"
                      onKeyDown={(e) => {
                        allowOnlyNumbers(e);
                      }}
                      trimOnBlur={false}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <MFTextField
                      name="fundAddress1"
                      label="Fund Address 1"
                      placeholder="Enter Fund Address 1"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <MFTextField
                      name="fundAddress2"
                      label="Fund Address 2"
                      placeholder="Enter Fund Address 2"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <MFTextField
                      name="fundAddress3"
                      label="Fund Address 3"
                      placeholder="Enter Fund Address 3"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <MFTextField name="custodian" label="Custodian" placeholder="Enter Custodian" />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <MFTextField
                      name="setupFee"
                      label="Setup Fee/Organizational Expenses"
                      placeholder="Enter Setup Fee/Organizational Expenses"
                      type="number"
                      onKeyDown={(e) => {
                        allowOnlyNumbers(e);
                      }}
                      trimOnBlur={false}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <MFTextField
                      name="minCommitmentAmount"
                      label="Minimum Commitment Amount *"
                      placeholder="Enter Minimum Commitment Amount"
                      type="number"
                      onKeyDown={(e) => {
                        allowOnlyNumbers(e);
                      }}
                      trimOnBlur={false}
                    />
                    {values.minCommitmentAmount != 0 && (
                      <Typography sx={{ fontSize: 13 }}>
                        {currencyConversion(values.minCommitmentAmount)}
                      </Typography>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <MFTextField
                      name="maxCommitmentAmount"
                      label="Maximum Commitment Amount *"
                      placeholder="Enter Maximum Commitment Amount"
                      type="number"
                      onKeyDown={(e) => {
                        allowOnlyNumbers(e);
                      }}
                      trimOnBlur={false}
                    />
                    {values.maxCommitmentAmount != 0 && (
                      <Typography sx={{ fontSize: 13 }}>
                        {currencyConversion(values.maxCommitmentAmount)}
                      </Typography>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <MFTextField
                      name="minContributionPercentage"
                      label="Minimum Contribution Percentage"
                      placeholder="Enter Minimum Contribution Percentage"
                      type="number"
                      onKeyDown={(e) => {
                        allowOnlyNumbers(e);
                      }}
                      trimOnBlur={false}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <MFTextField
                      name="operatingExpenses"
                      label="Operating Expenses"
                      placeholder="Enter Operating Expenses"
                      type="number"
                      onKeyDown={(e) => {
                        allowOnlyNumbers(e);
                      }}
                      trimOnBlur={false}
                    />
                  </Grid>
                  <Grid sx={{ marginTop: '30px' }} item xs={12} sm={6} md={4}>
                    <MFCheckbox
                      name={`managementFeeCheck`}
                      label="Enable Management Fee(After Onboarding)"
                      sx={{ my: 1 }}
                      onChange={({ target: { checked } }) => {
                        setValues({
                          ...values,
                          managementFeeCheck: checked,
                        });
                      }}
                      checked={values.managementFeeCheck}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <MFTextField
                      name="managementFee"
                      label={`Management Fee ${
                        values.managementFeeCheck ? '(During Commitment Period)' : ''
                      }`}
                      placeholder={`Enter Management Fee${
                        values.managementFeeCheck ? '(During Commitment Period)' : ''
                      }`}
                      type="number"
                      onKeyDown={(e) => {
                        allowOnlyNumbers(e);
                      }}
                      trimOnBlur={false}
                    />
                  </Grid>
                  {values.managementFeeCheck && (
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="managementFeeAfterCommitment"
                        label={`Management Fee (After the Commitment Period)`}
                        placeholder="Enter Management Fee(After the Commitment Period)"
                        type="number"
                        onKeyDown={(e) => {
                          allowOnlyNumbers(e);
                        }}
                        trimOnBlur={false}
                      />
                    </Grid>
                  )}
                  <Grid item xs={12} sm={6} md={4}>
                    <UseRadioGroup
                      formLabel="Accredited Investor Applicable *"
                      name={`accreditedInvestorApplicable`}
                      items={Object.keys(yesNoMaster).map((item) => ({
                        label: yesNoMaster[item],
                        value: item,
                      }))}
                    />
                  </Grid>
                  {isAccreditedInvestorApplicable(values.accreditedInvestorApplicable) && (
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="accreditedMinCommitmentAmount"
                        label="Accredited Minimum Commitment Amount *"
                        placeholder="Enter Accredited Minimum Commitment Amount"
                        type="number"
                        onKeyDown={(e) => {
                          allowOnlyNumbers(e);
                        }}
                        trimOnBlur={false}
                      />
                      {values.accreditedMinCommitmentAmount != 0 && (
                        <Typography sx={{ fontSize: 13 }}>
                          {currencyConversion(values.accreditedMinCommitmentAmount)}
                        </Typography>
                      )}
                    </Grid>
                  )}
                  {/* <Grid item xs={12} sm={6} md={4}>
                    <MFSelectField
                      name="hurdleRate"
                      label="Hurdle Rate"
                      items={hurdleRateMaster.map((item) => ({
                        key: item.displayText,
                        value: item.hurdleRate,
                      }))}
                      onChange={(e) => {
                        setValues({
                          ...values,
                          performanceFee:
                            hurdleRateMaster?.find((item) => item.hurdleRate === e.target.value)
                              ?.performanceFee || 0,
                          hurdleRate: (e.target.value as number) || 0,
                        });
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <MFTextField
                      name="performanceFee"
                      label="Performance Fee"
                      placeholder="Enter Performance Fee"
                      type="number"
                      onKeyDown={(e) => {
                        allowOnlyNumbers(e);
                      }}
                      trimOnBlur={false}
                      disabled={!Enable_Performance_Fee}
                    />
                  </Grid> */}
                  {/* <Grid item xs={12} sm={6} md={4}>
                    <MFTextField
                      name="placementCost"
                      label="Placement Cost"
                      placeholder="Enter Placement Cost"
                      type="number"
                      onKeyDown={(e) => {
                        allowOnlyNumbers(e);
                      }}
                      trimOnBlur={false}
                    />
                  </Grid> */}
                  <Grid item xs={12} sm={6} md={4}>
                    <MFTextField name="tcLink" label={`T&C Link`} placeholder={`Enter T&C Link`} />
                  </Grid>
                  {checkIfApplicable(checkExcludeClause) && (
                    <Grid item xs={12}>
                      <UseRadioGroup
                        formLabel="Excuse and Exclude Clause Undersigning *"
                        subLabel={excludeClauseSubLabel}
                        name={`excludeClause`}
                        items={Object.keys(EXCLUDE_CLAUSE_MASTER).map((clause) => ({
                          label: EXCLUDE_CLAUSE_MASTER[clause],
                          value: clause,
                        }))}
                      />
                    </Grid>
                  )}
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    sx={{ '.MuiFormControl-root': { marginTop: '16px' } }}>
                    <UseRadioGroup
                      name={`exitChargeApplicable`}
                      formLabel={`Exit Charges Applicable *`}
                      items={Object.keys(yesNoMaster).map((item) => ({
                        label: yesNoMaster[item],
                        value: item,
                      }))}
                    />
                  </Grid>
                  {checkIfApplicable(values.exitChargeApplicable) && (
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={4}
                      sx={{ pl: { xs: 0, sm: '28px' }, mt: { xs: 2, sm: 0 } }}>
                      <MFTextField
                        name="exitCharge"
                        multiline
                        rows={4.5}
                        label={`Exit Charge *`}
                        placeholder={`Enter Exit Charge`}
                      />
                    </Grid>
                  )}
                  <Grid item xs={12} sm={12} md={12}>
                    <DataTable
                      tableData={values.hurdlerates.filter((obj) => obj.isActive)}
                      tableHeader={[...columns, ...AccessViewOrEditCell]}
                      noOfPages={1}
                      renderAdditionalRow={true}
                      tableBodyCustomStyles={{
                        '.MuiTableCell-root': {
                          borderBottom: 'none',
                        },
                      }}
                      tableHeaderCustomStyles={{
                        '.MuiTableCell-head': {
                          fontFamily: 'Poppins, sans-serif',
                          fontSize: 14,
                          fontWeight: 500,
                          color: 'primary.main',
                          textAlign: 'left',
                          pl: 2,
                        },
                      }}
                      rowCustomStyles={{
                        '.MuiTableCell-root': {
                          py: 0,
                          overflowWrap: 'anywhere',
                          textAlign: 'left',
                          verticalAlign: 'top',
                        },
                      }}
                      boxStyles={{ minHeight: '0px', minWidth: 450, maxHeight: 'unset' }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      variant="outlined"
                      startIcon={<AddIcon />}
                      sx={{
                        color: 'primary.main',
                        fontWeight: 500,
                        fontSize: 14,
                        mt: 2,
                      }}
                      onClick={() =>
                        setValues({
                          ...values,
                          hurdlerates: [
                            ...values.hurdlerates,
                            { ...newHurdleRate, sno: values.hurdlerates.length },
                          ],
                        })
                      }>
                      Add Hurdle Rate
                    </Button>
                  </Grid>
                  <ConfirmationDialog
                    message={'Are you sure you want to delete hurdleRate ?'}
                    open={hurdleRateToDelete !== null}
                    setOpen={() => {
                      setHurdleRateToDelete(null);
                    }}
                    onSave={() => {
                      const remainedHurdleRates = values.hurdlerates.map((obj) => {
                        if (obj.sno === hurdleRateToDelete?.index) {
                          return {
                            ...obj,
                            isActive: false,
                          };
                        }
                        return obj;
                      });
                      setValues({
                        ...values,
                        hurdlerates: remainedHurdleRates,
                      });
                      setHurdleRateToDelete(null);
                    }}
                    onCancel={() => {
                      setHurdleRateToDelete(null);
                    }}
                  />
                  {/* empty grid for proper alignment */}
                  <Grid xs={12}></Grid>
                  <Grid item xs={12} sm={6} sx={{ mt: 2 }}>
                    <Box sx={{ display: 'flex' }}>
                      <MFCheckbox name={`isApplicableForDirect`} label="Direct" />
                      <MFCheckbox
                        name={`isApplicableForDistributor`}
                        label="Distributor"
                        onChange={({ target: { checked } }) => {
                          setValues({
                            ...values,
                            isApplicableForDistributor: checked,
                            distributorIds: [],
                          });
                        }}
                        checked={values.isApplicableForDistributor}
                      />
                    </Box>
                    {values.isApplicableForDistributor && (
                      <MultipleSelect
                        name="distributorIds"
                        label="Applicable Distributor(s) *"
                        items={distributorList.map((item) => ({
                          key: item.id,
                          value: `${item.arnCode || 'N/A'} - ${item.name} (${item.type})`,
                        }))}
                        renderText="Selected Distributor(s)"
                      />
                    )}
                  </Grid>{' '}
                </Grid>
                {values?.isApplicableForDistributor && (
                  <Grid container rowSpacing={1} columnSpacing={4} px={2}>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="distMangementFee"
                        label=" Distribution/ Placement Fees *"
                        placeholder="Enter  Distribution/ Placement Fees"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="distPerformanceFee"
                        label="Distribution Commission: Performance Fees *"
                        placeholder="Enter Distribution Commission: Performance Fees"
                      />
                    </Grid>
                  </Grid>
                )}
                {access && (
                  <Box sx={{ width: '100%', maxWidth: '350px', mx: 'auto', mt: 3 }}>
                    <MFSubmitButton label="Save" />
                  </Box>
                )}
              </>
            )}
          </Box>
        )}
      </Formik>
    </>
  );
}
